<template>
  <div class="materials-management">
    <div class="page-header">
      <h2>素材管理</h2>
      <div class="header-buttons">
        <!-- <el-button type="primary" @click="showBatchManageDialog" :disabled="!selectedMaterials.length">
          批量管理 <span v-if="selectedMaterials.length">({{ selectedMaterials.length }})</span>
        </el-button> -->
        <el-button
          type="primary"
          @click="showTagDialog"
          :disabled="!selectedMaterials.length"
        >
          打标签
        </el-button>
        <el-button
          type="primary"
          @click="showBatchUploadDialog"
          style="margin-right: 10px"
          >批量上传</el-button
        >
        <el-button type="primary" @click="handleAdd">添加素材</el-button>
        <el-button type="success" @click="showCategoryDialog"
          >分类管理</el-button
        >
      </div>
    </div>

    <!-- 搜索和筛选区域 -->
    <div class="filter-section">
      <el-form :inline="true" :model="filterForm">
        <el-form-item label="分类">
          <el-cascader
            v-model="filterForm.category"
            :options="categoryOptions"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
            }"
            placeholder="选择分类"
            clearable
            @change="handleCategoryChange"
          />
        </el-form-item>
        <el-form-item label="搜索">
          <el-input
            v-model="filterForm.keyword"
            placeholder="输入关键词搜索"
            clearable
            @input="handleSearch"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 素材列表 -->
    <el-table
      :data="materials"
      v-loading="loading"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="预览图" width="120">
        <template #default="{ row }">
          <el-image
            :src="row.preview_url"
            :preview-src-list="[getFullUrl(row.preview_url)]"
            :initial-index="0"
            fit="cover"
            class="table-image"
            :preview-teleported="true"
            @error="handleImageError"
          >
            <template #error>
              <div class="image-error">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="150" />
      <el-table-column label="标签" width="120">
        <template #default="{ row }">
          <div
            v-if="row.tags && row.tags.length"
            style="display: flex; flex-wrap: wrap; gap: 5px"
          >
            <el-tag
              v-for="(tag, index) in row.tags"
              :key="tag.id"
              type="primary"
              size="small"
            >
              {{ tag.tag_name }}
            </el-tag>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="category_name" label="分类" width="120" />
      <el-table-column label="文件" width="200">
        <template #default="{ row }">
          <div class="file-icons">
            <el-tooltip v-if="row.fla_file" content="FLA文件" placement="top">
              <div class="file-icon fla" />
            </el-tooltip>
            <el-tooltip v-if="row.psd_file" content="PSD文件" placement="top">
              <div class="file-icon psd" />
            </el-tooltip>
            <!-- 如果没有任何文件，显示提示 -->
            <span v-if="!row.fla_file && !row.psd_file" class="no-files">
              无文件
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="统计" width="150">
        <template #default="{ row }">
          <div class="stats">
            <el-tooltip content="查看次数" placement="top">
              <span>
                <el-icon><View /></el-icon>
                {{ row.view_count }}
              </span>
            </el-tooltip>
            <el-tooltip content="下载次数" placement="top">
              <span>
                <el-icon><Download /></el-icon>
                {{ row.download_count }}
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template #default="{ row }">
          <el-tag :type="row.status === 'active' ? 'success' : 'info'">
            {{ row.status === "active" ? "启用" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="{ row }">
          <el-button-group>
            <el-button size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button size="small" type="primary" @click="handleTags(row)">标签</el-button>
            <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination-container">
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 添加/编辑素材对话框 -->
    <MaterialDialog
      v-if="dialogVisible"
      v-model:visible="dialogVisible"
      :material="tagDialogMaterial"
      :categories="categoryOptions"
      @save="handleDialogSave"
      @cancel="handleDialogCancel"
    />

    <!-- 标签 -->
    <TagsDialog
      v-if="tagsDialogVisible"
      v-model:visible="tagsDialogVisible"
      :material="tagDialogMaterial"
      :tags="tags"
      @save="handleTagsDialogSave"
      @cancel="handleTagsDialogCancel"
    />

    <MaterialDetailDialog
      v-if="selectedMaterial"
      v-model:visible="detailVisible"
      :material="selectedMaterial"
      @update="handleMaterialUpdate"
    />

    

    <!-- 添加批量上传对话框 -->
    <el-dialog
      v-model="batchUploadVisible"
      title="批量上传素材"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form :model="batchUploadForm" label-width="120px">
        <el-form-item label="选择分类" required>
          <el-cascader
            v-model="batchUploadForm.category_id"
            :options="categoryOptions"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
            }"
            placeholder="选择分类"
          />
        </el-form-item>

        <el-form-item label="预览图文件" required>
          <el-upload
            ref="previewUpload"
            action="#"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="true"
            :on-change="handlePreviewChange"
            accept=".jpg,.jpeg"
          >
            <el-button type="primary">选择预览图文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传jpg/png/gif文件，且文件名需要与FLA/PSD文件名匹配
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item label="预览图下载" required>
          <el-upload
            ref="previewDwUpload"
            action="#"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="true"
            :on-change="handlePreviewDwChange"
            accept=".png"
          >
            <el-button type="primary">选择预览图下载文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传jpg/png/gif文件，且文件名需要与FLA/PSD文件名匹配
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item label="FLA文件">
          <el-upload
            ref="flaUpload"
            action="#"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="true"
            :on-change="handleFlaChange"
            accept=".fla"
          >
            <el-button type="primary">选择FLA文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传FLA文件，文件名需要与预览图匹配
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item label="PSD文件">
          <el-upload
            ref="psdUpload"
            action="#"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="true"
            :on-change="handlePsdChange"
            accept=".psd"
          >
            <el-button type="primary">选择PSD文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传PSD文件，文件名需要与预览图匹配
              </div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>

      <!-- 添加上传进度条 -->
      <div v-if="uploadInProgress" class="upload-progress-container">
        <p class="progress-text">上传进度: {{ uploadPercentage }}%</p>
        <el-progress
          :percentage="uploadPercentage"
          :stroke-width="18"
          status="success"
        />
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button
            @click="batchUploadVisible = false"
            :disabled="uploadInProgress"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="handleBatchUpload"
            :loading="batchUploading"
          >
            开始上传
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 上传结果对话框 -->
    <el-dialog v-model="resultDialogVisible" title="上传结果" width="50%">
      <div class="upload-result">
        <div class="result-summary">
          <p>总计：{{ uploadResult.total }} 个文件</p>
          <p class="success">成功：{{ uploadResult.successCount }} 个</p>
          <p class="error">失败：{{ uploadResult.errorCount }} 个</p>
        </div>

        <template v-if="uploadResult.errors && uploadResult.errors.length > 0">
          <h4>失败详情：</h4>
          <el-table :data="uploadResult.errors" style="width: 100%">
            <el-table-column prop="fileName" label="文件名" />
            <el-table-column prop="error" label="错误原因" />
          </el-table>
        </template>
      </div>
    </el-dialog>

    <!-- 批量管理对话框 -->
    <el-dialog v-model="batchManageVisible" title="批量管理" width="500px">
      <div class="batch-manage-content">
        <p>已选择 {{ selectedMaterials.length }} 个素材</p>
        <div class="batch-actions">
          <el-button type="danger" @click="handleBatchDelete"
            >批量删除</el-button
          >
          <div class="category-update">
            <el-cascader
              v-model="targetCategoryId"
              :options="categoryOptions"
              :props="{
                checkStrictly: true,
                label: 'name',
                value: 'id',
                emitPath: false,
              }"
              placeholder="选择目标分类"
              clearable
            >
            </el-cascader>
            <el-button
              type="primary"
              @click="handleBatchUpdateCategory"
              :disabled="!targetCategoryId"
            >
              更新分类
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 分类管理对话框 -->
    <CategoryManagement
      v-model:visible="categoryDialogVisible"
      @refresh="handleCategoryRefresh"
    />

    <!-- 打标签对话框 -->
    <el-dialog
      v-model="tagDialogVisible"
      title="为素材打标签"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form :model="{}" label-width="80px">
        <el-form-item label="选中素材">
          <el-input v-model="selectedMaterialsCount" disabled />
        </el-form-item>
        <el-form-item label="选择标签">
          <el-tree-select
            v-model="selectedTags"
            :data="tags"
            :props="{
              label: 'tag_name',
              value: 'id',
              children: 'children',
            }"
            placeholder="选择标签"    
            multiple
            filterable
            allow-create
            default-first-option
            :reserve-keyword="false"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="tagDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSaveTags">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { getCategories, MaterialService, saveTags } from "../../api/material";
import { getAllTags, getTags } from "../../api/tags";
import { ref, reactive, computed, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Search, View, Download, Picture } from "@element-plus/icons-vue";
import MaterialDialog from "@/components/material/MaterialDialog.vue";
import TagsDialog from "@/components/tags/TagsDialog.vue";
import MaterialDetailDialog from "@/components/materials/MaterialDetailDialog.vue";
import request from "@/utils/request";
import CategoryManagement from "../../components/admin/CategoryManagement.vue";

interface Material {
  id: number;
  title: string;
  type: string;
  preview_image: string;
  preview_url: string;
  category_name: string;
  fla_file?: string;
  psd_file?: string;
  view_count: number;
  download_count: number;
  status: string;
}

interface UploadFile {
  name: string;
  raw: File;
  status: string;
}

// 错误处理类型
interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
}

// 状态定义
const tagsDialogVisible = ref(false);
const tagDialogMaterial = ref<Material | null>(null);

const dialogVisible = ref(false);
const tagDialogVisible = ref(false);
const tags = ref([]);
const selectedTags = ref([]);
const currentMaterialForTags = ref({});
const loading = ref(true);
const materials = ref<Material[]>([]);
const currentMaterial = ref<Material | null>(null);
const total = ref(0);
const pageSize = ref(10);
const currentPage = ref(1);
const detailVisible = ref(false);
const selectedMaterial = ref<Material | null>(null);
const batchUploadVisible = ref(false);
const resultDialogVisible = ref(false);
const previewUpload = ref<any>(null);
const previewDwUpload = ref<any>(null);
const flaUpload = ref<any>(null);
const psdUpload = ref<any>(null);
const batchUploading = ref(false);
const selectedMaterials = ref<Material[]>([]);
const batchManageVisible = ref(false);
const targetCategoryId = ref<number | null>(null);
const uploadInProgress = ref(false);
const uploadPercentage = ref(0);
const categoryDialogVisible = ref(false);

const backendUrl = ref(import.meta.env.VITE_JAVA_API_URL);

const filterForm = ref({
  category: null as number[] | null,
  keyword: "",
  status: "all",
  type: "all",
  sort: "newest",
});




const categoryOptions = ref([]);


// 处理标签
const handleTags = async (material: Material) => {
    tagDialogMaterial.value = material;
    tagsDialogVisible.value = true;
};


// 处理对话框成功
const handleTagsDialogSave = () => {
  tagsDialogVisible.value = false;
  // 刷新素材列表
  fetchMaterials(buildQueryParams());
};

const handleTagsDialogCancel = () => {
  tagsDialogVisible.value = false;
};



// 计算选中的素材数量
const selectedMaterialsCount = computed(() => {
  return `共 ${selectedMaterials.value.length} 个素材`;
});

// 批量上传表单数据
const batchUploadForm = reactive({
  category_id: null as number[] | null,
  previewFiles: [] as UploadFile[],
  previewDwFiles: [] as UploadFile[],
  flaFiles: [] as UploadFile[],
  psdFiles: [] as UploadFile[],
});

// 上传结果
const uploadResult = reactive({
  total: 0,
  successCount: 0,
  errorCount: 0,
  success: [] as any[],
  errors: [] as any[],
});

// 加载标签数据
const loadTags = async () => {
  try {
    const response = await getTags({});
    if (response && response.data.code === 200) {
      tags.value = response.data.data;
    } else {
      tags.value = [];
      throw new Error("获取标签失败，返回数据不是数组");
    }
  } catch (error) {
    console.error("获取标签失败:", error);
    tags.value = [];
    ElMessage.error("获取标签失败");
  }
};

// 获取分类数据
const fetchCategories = async () => {
  try {
    const response = await getCategories();
    if (response) {
      console.log("Categories loaded:", response.data.data); // 添加调试日志
      categoryOptions.value = response.data.data;
    } else {
      throw new Error("获取分类失败");
    }

    //     const response = await fetch(`${backendUrl.value}/api/materials/categories`, {
    //   headers: {
    //     'Authorization': `Bearer ${localStorage.getItem('token')}`
    //   }
    // });

    // if (response.ok) {
    //   const data = await response.json();
    //   console.log('Categories loaded:', data); // 添加调试日志
    //   categoryOptions.value = data;
    // } else {
    //   throw new Error('获取分类失败');
    // }
  } catch (error) {
    console.error("获取分类失败:", error);
    ElMessage.error("获取分类失败");
  }
};

// 获取素材列表
const fetchMaterials = async (params: any = {}) => {
  console.log("获取素材列表");
  try {
    loading.value = true;
    const queryParams = new URLSearchParams({
      page: params.page?.toString() || currentPage.value.toString(),
      limit: params.limit?.toString() || pageSize.value.toString(),
    });

    // 添加分类ID
    if (params.category_id) {
      queryParams.append("category_id", params.category_id.toString());
    }

    // 添加关键词
    if (params.keyword) {
      queryParams.append("keyword", params.keyword);
    }

    console.log(
      "Fetching materials with params:",
      Object.fromEntries(queryParams)
    );

    const response = await MaterialService.getList(queryParams);
    // const response = await fetch(`/api/materials?${queryParams}`);
    if (!response) {
      throw new Error("获取素材列表失败");
    }

    const data = await response.data;
    console.log("Materials data:", data);

    materials.value = response.data.data;
    total.value = data.pagination.total;
  } catch (error) {
    console.error("获取素材列表失败:", error);
    ElMessage.error("获取素材列表失败");
  } finally {
    loading.value = false;
  }
};

// 处理添加素材
const handleAdd = () => {
  currentMaterial.value = null;
  dialogVisible.value = true;
};

// 处理编辑素材
const handleEdit = async (material: Material) => {
  try {
    // 加载素材详细信息
    const response = await fetch(`/api/materials/${material.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      throw new Error("获取素材详情失败");
    }

    const materialDetail = await response.json();
    console.log("Material detail loaded:", materialDetail);

    // 设置当前编辑的素材
    currentMaterial.value = materialDetail;
    dialogVisible.value = true;
  } catch (error) {
    console.error("获取素材详情失败:", error);
    ElMessage.error("获取素材详情失败");
  }
};



// 处理删除素材
const handleDelete = async (material: Material) => {
  try {
    await ElMessageBox.confirm("确定要删除这个素材吗？");
    const response = await fetch(`/api/materials/${material.id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.ok) {
      ElMessage.success("删除成功");
      // 保持当前筛选条件
      fetchMaterials(buildQueryParams());
    }
  } catch (error) {
    if (error !== "cancel") {
      console.error("删除素材失败:", error);
      ElMessage.error("删除素材失败");
    }
  }
};

// 处理搜索
const handleSearch = async () => {
  currentPage.value = 1; // 搜索时重置为第1页
  fetchMaterials(buildQueryParams(1, pageSize.value));
};

// 处理分页
const handleSizeChange = (val: number) => {
  pageSize.value = val;
  // 改变每页显示数量时重置为第1页
  currentPage.value = 1;
  fetchMaterials(buildQueryParams(1, val));
};

const handleCurrentChange = (val: number) => {
  currentPage.value = val;
  fetchMaterials(buildQueryParams(val, pageSize.value));
};

// 处理对话框成功
const handleDialogSave = () => {
  dialogVisible.value = false;
  // 保持当前筛选条件
  fetchMaterials(buildQueryParams());
};

const handleDialogCancel = () => {
  dialogVisible.value = false;
};

// 处理分类变化
const handleCategoryChange = (value: number[]) => {
  // 如果清空了分类选择
  if (!value || value.length === 0) {
    filterForm.value.category = null;
  }

  // 分类变化时重置为第1页
  currentPage.value = 1;
  fetchMaterials(buildQueryParams(1, pageSize.value));
};

// 获取完整URL（包含域名）
const getFullUrl = (url: string) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;

  // 使用正确的端口
  const baseUrl = "http://localhost:3001";
  const cleanPath = url.replace(/^\/+/, "");
  return `${baseUrl}/${cleanPath}`;
};

// 获取相对URL（用于缩略图）
const getPreviewUrl = (url: string) => {
  if (!url) return "";

  request
    .post(`${backendUrl.value}/file/getImagePreview`, {
      objectName: url,
    })
    .then((res: any) => {
      console.log("--- 获取预览图");
      console.log(res.data.data.data.url);
      return res.data.data.data.url;
    });
};

// 处理图片加载错误
const handleImageError = (e: Event) => {
  const img = e.target as HTMLImageElement;
  // console.error('Image load error:', {
  //   src: img.src,
  //   naturalWidth: img.naturalWidth,
  //   naturalHeight: img.naturalHeight
  // });
};

// 处理素材更新
const handleMaterialUpdate = (updatedMaterial: Material) => {
  // 更新列表中的素材数据
  const index = materials.value.findIndex((m) => m.id === updatedMaterial.id);
  if (index !== -1) {
    materials.value[index] = { ...materials.value[index], ...updatedMaterial };
  }
};

// 处理选择变化
const handleSelectionChange = (selection: Material[]) => {
  selectedMaterials.value = selection;
};

// 显示打标签对话框
const showTagDialog = () => {
  if (selectedMaterials.value.length === 0) {
    ElMessage.warning("请选择至少一个素材进行打标签");
    return;
  }
  currentMaterialForTags.value = selectedMaterials.value;
  // 清空之前选择的标签
  selectedTags.value = [];
  tagDialogVisible.value = true;
};

// 显示批量管理对话框
const showBatchManageDialog = () => {
  if (selectedMaterials.value.length === 0) {
    ElMessage.warning("请先选择要管理的素材");
    return;
  }
  batchManageVisible.value = true;
};

// 批量删除
const handleBatchDelete = async () => {
  try {
    await ElMessageBox.confirm(
      `确定要删除选中的 ${selectedMaterials.value.length} 个素材吗？此操作不可恢复！`,
      "警告",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    );

    const response = await request.post("/materials/batch-delete", {
      material_ids: selectedMaterials.value.map((m) => m.id),
    });

    if (response.data.success) {
      ElMessage.success(response.data.message);
      // 刷新列表，保持当前筛选条件
      fetchMaterials(buildQueryParams());
      // 关闭对话框
      batchManageVisible.value = false; 
      // 清空选择
      selectedMaterials.value = [];
    }
  } catch (error) {
    if (error !== "cancel") {
      console.error("批量删除失败:", error);
      const apiError = error as ApiError;
      ElMessage.error(apiError.response?.data?.message || "批量删除失败");
    }
  }
};

// 保存标签
const handleSaveTags = async () => {
  if (!selectedTags.value || selectedTags.value.length === 0) {
    ElMessage.warning("请选择标签");
    return;
  }

  try {
    // 获取所有选中的素材ID
    const materialIds = currentMaterialForTags.value.map(
      (material) => material.id
    );

    // 调用后端API为多个素材打标签
    const response = await saveTags({
      material_ids: materialIds,
      tag_ids: selectedTags.value,
    });

    if (response.data.code == 200) {
      ElMessage.success(`成功为 ${materialIds.length} 个素材打标签`);
      tagDialogVisible.value = false;
      // 刷新素材列表
      fetchMaterials(buildQueryParams());
    } else {
      throw new Error(response.data.message || "打标签失败");
    }
  } catch (error) {
    console.error("打标签失败:", error);
    ElMessage.error(error.message || "打标签失败");
  }
};

// 批量更新分类
const handleBatchUpdateCategory = async () => {
  if (!targetCategoryId.value) {
    ElMessage.warning("请选择目标分类");
    return;
  }

  try {
    const response = await request.post("/materials/batch-update-category", {
      material_ids: selectedMaterials.value.map((m) => m.id),
      category_id: targetCategoryId.value,
    });

    if (response.data.success) {
      ElMessage.success(response.data.message);
      // 刷新列表，保持当前筛选条件
      fetchMaterials(buildQueryParams());
      // 关闭对话框
      batchManageVisible.value = false;
      // 清空选择
      selectedMaterials.value = [];
      // 重置目标分类
      targetCategoryId.value = null;
    }
  } catch (error) {
    console.error("批量更新分类失败:", error);
    const apiError = error as ApiError;
    ElMessage.error(apiError.response?.data?.message || "批量更新分类失败");
  }
};

// 显示批量上传对话框
const showBatchUploadDialog = () => {
  batchUploadVisible.value = true;
  // 重置表单
  batchUploadForm.category_id = null;
  batchUploadForm.previewFiles = [];
  batchUploadForm.previewDwFiles = [];
  batchUploadForm.flaFiles = [];
  batchUploadForm.psdFiles = [];
  // 重置上传组件
  if (previewUpload.value) previewUpload.value.clearFiles();
  if (previewDwUpload.value) previewDwUpload.value.clearFiles();
  if (flaUpload.value) flaUpload.value.clearFiles();
  if (psdUpload.value) psdUpload.value.clearFiles();
  // 打开窗口的时候重置uploadResult
  uploadResult.total = 0;
  uploadResult.successCount = 0;
  uploadResult.errorCount = 0;
  uploadResult.success = [];
  uploadResult.errors = [];
};

// 处理文件选择
const handlePreviewChange = (file: UploadFile) => {
  if (file.status === "ready") {
    batchUploadForm.previewFiles.push(file);
  }
};
// 处理文件选择
const handlePreviewDwChange = (file: UploadFile) => {
  if (file.status === "ready") {
    batchUploadForm.previewDwFiles.push(file);
  }
};

const handleFlaChange = (file: UploadFile) => {
  if (file.status === "ready") {
    batchUploadForm.flaFiles.push(file);
  }
};

const handlePsdChange = (file: UploadFile) => {
  if (file.status === "ready") {
    batchUploadForm.psdFiles.push(file);
  }
};

// 批量上传处理
const handleBatchUpload = async () => {
  if (!batchUploadForm.category_id) {
    ElMessage.warning("请选择分类");
    return;
  }

  if (batchUploadForm.previewFiles.length === 0) {
    ElMessage.warning("请选择预览图文件");
    return;
  }

  if (batchUploadForm.previewDwFiles.length === 0) {
    ElMessage.warning("请选择预览图文件");
    return;
  }

  if (
    batchUploadForm.flaFiles.length === 0 &&
    batchUploadForm.psdFiles.length === 0
  ) {
    ElMessage.warning("请至少选择FLA文件或PSD文件");
    return;
  }

  // 检查文件大小限制
  const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
  const checkFileSize = (files: UploadFile[]) => {
    return files.every((file) => {
      if (file.raw.size > MAX_FILE_SIZE) {
        ElMessage.error(`文件 ${file.name} 超过100MB大小限制`);
        return false;
      }
      return true;
    });
  };

  if (
    !checkFileSize(batchUploadForm.previewFiles) ||
    !checkFileSize(batchUploadForm.previewDwFiles) ||
    !checkFileSize(batchUploadForm.flaFiles) ||
    !checkFileSize(batchUploadForm.psdFiles)
  ) {
    return;
  }

  batchUploading.value = true;
  uploadInProgress.value = true;
  uploadPercentage.value = 0;

  try {
    const formData = new FormData();
    //把所有图片分组
    const materialMap = new Map();

    // 从级联选择器中获取最终选择的分类ID
    const categoryId = Array.isArray(batchUploadForm.category_id)
      ? batchUploadForm.category_id[batchUploadForm.category_id.length - 1]
      : batchUploadForm.category_id;

    formData.append("category_id", categoryId?.toString() || "");

    // 首先收集所有预览图
    // 添加预览图文件
    batchUploadForm.previewFiles.forEach((file) => {
      const raw = file.raw;
      const itemname = raw.name.split(".")[0];
      const newFileName = generateFileName(raw.name);
      const renamedFile = new File([raw], newFileName, { type: raw.type });
      materialMap.set(itemname, {
        name: itemname,
        categoryId: categoryId,
        preview: renamedFile,
        previewName: "preview/" + newFileName,
        previewDw: null,
        previewDwName: null,
        flaName: null,
        fla: null,
        psdName: null,
        psd: null,
      });
    });

    // 添加预览图文件
    batchUploadForm.previewDwFiles.forEach((file) => {
      const raw = file.raw;
      const itemname = raw.name.split(".")[0];
      const newFileName = generateFileName(raw.name);
      // 创建新的File对象（保持原始文件数据，只修改名字）
      const renamedFile = new File([raw], newFileName, { type: raw.type });
      if (materialMap.has(itemname)) {
        materialMap.get(itemname).previewDwName = "previewdw/" + newFileName;
        materialMap.get(itemname).previewDw = renamedFile;
      }
    });

    // 添加FLA文件
    batchUploadForm.flaFiles.forEach((file) => {
      const raw = file.raw;
      // 生成新文件名
      const itemname = raw.name.split(".")[0];

      const newFileName = generateFileName(raw.name);
      // 创建新的File对象（保持原始文件数据，只修改名字）
      const renamedFile = new File([raw], newFileName, { type: raw.type });
      if (materialMap.has(itemname)) {
        materialMap.get(itemname).flaName = "fla/" + newFileName;
        materialMap.get(itemname).fla = renamedFile;
      }
    });

    // 添加PSD文件
    batchUploadForm.psdFiles.forEach((file) => {
      const raw = file.raw;
      // 生成新文件名
      const itemname = raw.name.split(".")[0];

      const newFileName = generateFileName(raw.name);
      // 创建新的File对象（保持原始文件数据，只修改名字）
      const renamedFile = new File([raw], newFileName, { type: raw.type });
      if (materialMap.has(itemname)) {
        materialMap.get(itemname).psdName = "psd/" + newFileName;
        materialMap.get(itemname).psd = renamedFile;
      }
    });

    // 计算总文件大小用于进度估算
    const totalFiles =
      batchUploadForm.previewFiles.length +
      batchUploadForm.previewDwFiles.length +
      batchUploadForm.flaFiles.length +
      batchUploadForm.psdFiles.length;
    console.log(`准备上传共 ${totalFiles} 个文件`);

    for (const [name, material] of materialMap.entries()) {
      if (material.preview) {
        await handUploadFile(material.previewName, material.preview);
      }
      if (material.previewDw) {
        await handUploadFile(material.previewDwName, material.previewDw);
      }
      if (material.fla) {
        await handUploadFile(material.flaName, material.fla);
      }
      if (material.psd) {
        await handUploadFile(material.psdName, material.psd);
      }

      // 请求后端保存素材上传记录
      const response = await request.post(
        `${backendUrl.value}/system/materials/batch-upload-v2`,
        {
          categoryId: categoryId,
          material: material,
        }
      );
    }

    // // 创建上传配置，增加超时时间和进度监控
    // const uploadConfig = {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   },
    //   timeout: 300000, // 增加超时时间到5分钟
    //   onUploadProgress: (progressEvent: { loaded: number; total?: number }) => {
    //     if (progressEvent.total) {
    //       // 更新进度条显示
    //       const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //       console.log(`上传进度: ${percentage}%`);
    //       uploadPercentage.value = percentage;
    //     }
    //   }
    // };
    //
    // // 使用增强的配置发送请求
    // const response = await request.post('/materials/batch-upload', formData, uploadConfig);
    //
    // // 更新上传结果
    // Object.assign(uploadResult, response.data.results);

    // 显示结果对话框
    batchUploadVisible.value = false;
    resultDialogVisible.value = true;

    // 如果有成功上传的文件，刷新素材列表
    if (uploadResult.successCount > 0) {
      fetchMaterials(buildQueryParams());
      ElMessage.success(`成功上传了 ${uploadResult.successCount} 个素材`);
    }
  } catch (error: any) {
    console.error("批量上传失败:", error);
    let errorMessage = "上传失败";

    if (error.code === "ECONNABORTED") {
      errorMessage =
        "上传超时，请检查文件大小或网络连接。建议分批上传较少的文件，或者减小文件大小。";
    } else if (error.code === "ERR_NETWORK") {
      errorMessage = "网络连接失败，请确保后端服务正在运行";
    } else if (error.response) {
      errorMessage = error.response.data?.message || "服务器返回错误";
    }

    ElMessage.error(errorMessage);
    console.log("详细错误信息:", {
      code: error.code,
      message: error.message,
      response: error.response,
      config: error.config,
    });
  } finally {
    batchUploading.value = false;
    uploadInProgress.value = false;
    uploadPercentage.value = 0;
  }
};

// 生成时间戳 + 6位随机数的文件名
const generateFileName = (originalName: string): string => {
  // 获取当前时间戳（毫秒）
  const timestamp = Date.now();

  // 生成6位随机数（100000-999999）
  const randomNum = Math.floor(100000 + Math.random() * 900000);

  // 获取文件扩展名
  const ext = originalName.split(".").pop() || "";

  // 组合成新文件名：时间戳_随机数.扩展名
  return `${timestamp}_${randomNum}.${ext}`;
};

// 获取上传URL上传oss
const handUploadFile = async (objectName: string, file: File | null) => {
  if (!file) return; // 如果文件不存在，直接返回

  try {
    console.log("上传文件", file);
    // 1. 获取预签名 URL
    const response = await fetch(`${backendUrl.value}/file/getUoloadUrl`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: JSON.stringify({
        objectName: objectName,
      }),
    });

    if (!response.ok) throw new Error("获取上传URL失败");

    const { data } = await response.json();
    const { url } = data.data;

    // 2. 上传文件到 OSS
    await uploadFile(file, url);

    uploadResult.total++;
    uploadResult.successCount++;
  } catch (error) {
    uploadResult.errorCount++;
    console.error("上传出错:", error);
  }
};

const uploadFile = async (file: File, presignedUrl: string) => {
  const response = await fetch(presignedUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": "application/octet-stream", // 必须与预签名 URL 的 contentType 一致
    },
    mode: "cors",
  });
};

// 显示分类管理对话框
const showCategoryDialog = () => {
  categoryDialogVisible.value = true;
};

// 在组件挂载时获取数据
onMounted(() => {
  fetchCategories();
  // 初始加载使用默认参数
  fetchMaterials(buildQueryParams());
  loadTags();
});

// 构建包含当前筛选条件的查询参数
const buildQueryParams = (page = currentPage.value, limit = pageSize.value) => {
  const params: any = {
    page,
    limit,
  };

  // 添加分类筛选条件
  if (filterForm.value.category) {
    params.category_id =
      filterForm.value.category[filterForm.value.category.length - 1];
  }

  // 添加关键词搜索条件
  if (filterForm.value.keyword) {
    params.keyword = filterForm.value.keyword.trim();
  }

  return params;
};

// 处理分类管理刷新
const handleCategoryRefresh = () => {
  fetchCategories();
  fetchMaterials(buildQueryParams());
};
</script>

<style scoped>
.materials-management {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-section {
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.preview-image {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  object-fit: cover;
}

.file-icons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.file-icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: transform 0.2s;
}

.file-icon:hover {
  transform: scale(1.1);
}

.file-icon.fla {
  background-image: url("@/assets/icons/fla.png");
}

.file-icon.psd {
  background-image: url("@/assets/icons/psd.png");
}

.no-files {
  color: #909399;
  font-size: 12px;
}

.stats {
  display: flex;
  gap: 16px;
}

.stats span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.table-image {
  width: 100px;
  height: 100%;
  border-radius: 4px;
}

.image-error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

:deep(.el-image-viewer__wrapper) {
  z-index: 2100; /* 确保预览层级高于其他元素 */
}

:deep(.el-image-viewer__mask) {
  z-index: 2099;
}

.header-buttons {
  display: flex;
}

.upload-result {
  padding: 20px;
}

.result-summary {
  margin-bottom: 20px;
}

.result-summary .success {
  color: #67c23a;
}

.result-summary .error {
  color: #f56c6c;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.header-actions {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.batch-manage-content {
  padding: 20px 0;
}

.batch-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.category-update {
  display: flex;
  gap: 10px;
  align-items: center;
}

.category-update .el-cascader {
  flex: 1;
}

/* 添加进度条样式 */
.upload-progress-container {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.progress-text {
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
}
</style>